<template>
  <router-view/>
</template>

<script>
export default {
  name: 'CustomTable'
}
</script>

<style scoped>

</style>